/* eslint-disable complexity */
import { Visibility, VisibilityOff } from '@mui/icons-material';
import {
  FormHelperText,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
} from '@mui/material';
import FormControl from '@mui/material/FormControl';
import React from 'react';
import { useTheme } from 'styled-components';
import { TextBoxProps } from 'src/types';

export const PasswordTextBox = (
  props: TextBoxProps & { direction: string },
) => {
  const { direction } = props;
  const theme = useTheme();
  const whiteColor = theme.isVaultVariant
    ? theme.newPalette.neutral.N0
    : theme.atlas.semantic.color.type.inverse;
  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const classes =
    props.classes && typeof props.classes === 'object'
      ? props.classes
      : undefined;
  const textboxClassName =
    typeof props.classes === 'string' ? props.classes : classes?.textbox;
  const whiteClassName = classes?.white;

  return (
    <div style={props.style} data-testid={props['data-testid']}>
      <FormControl style={{ minWidth: '100%' }}>
        <InputLabel
          htmlFor="adornment-password"
          className={props.isWhite ? whiteClassName : textboxClassName}
          classes={
            props.isWhite
              ? {
                  focused: classes?.focussed,
                  formControl: classes?.focussed,
                }
              : undefined
          }
          style={
            props.isWhite
              ? { color: whiteColor, borderBottom: 'none' }
              : undefined
          }
        >
          {props.placeholder}
        </InputLabel>
        <Input
          data-testid={'password-input'}
          autoComplete={props.autoComplete}
          className={props.isWhite ? whiteClassName : textboxClassName}
          classes={
            props.isWhite
              ? {
                  focused: classes?.focussed,
                  underline: classes?.underline,
                }
              : undefined
          }
          id={props.id}
          type={showPassword ? 'text' : 'password'}
          value={props.value}
          error={!props.valid}
          onChange={props.onChange}
          onKeyPress={(e) => {
            if (props.enterKeyAction && e.charCode === 13) {
              e.preventDefault();
              props.enterKeyAction();
            }
          }}
          endAdornment={
            direction === 'ltr' && (
              <InputAdornment position={'end'}>
                <IconButton
                  aria-label="Toggle password visibility"
                  onClick={handleClickShowPassword}
                  style={props.isWhite ? { color: whiteColor } : undefined}
                  size="large"
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            )
          }
          startAdornment={
            direction === 'rtl' && (
              <InputAdornment position={'start'}>
                <IconButton
                  aria-label="Toggle password visibility"
                  onClick={handleClickShowPassword}
                  style={props.isWhite ? { color: whiteColor } : undefined}
                  size="large"
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            )
          }
        />
        {props.showHelpertext ? (
          <FormHelperText
            className={whiteClassName}
            id="component-error-text"
            data-testid="component-error-text"
          >
            Your password must be at least 9 characters long and contain at
            least one uppercase letter and one number
          </FormHelperText>
        ) : null}
      </FormControl>
    </div>
  );
};
